export default "__VITE_ASSET__CPulfdtE__"